/** Pilot orgs allowed to use managed-ads Instagram partner post UI. Remove when GA. */
const MANAGED_ADS_PARTNER_POST_PILOT_ORG_IDS = new Set<string>([
  // Apple Review Org
  "ORe05ba45c-a4fd-43d9-87b5-754c3f937475",
]);

export function isManagedAdsPartnerPostsEnabledForOrg(
  organizationId: string | null | undefined
): boolean {
  const id = organizationId?.trim();
  return Boolean(id && MANAGED_ADS_PARTNER_POST_PILOT_ORG_IDS.has(id));
}
